import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n";
import { apiErrorMessage } from "../lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Signed in as ${u.role}`);
      if (u.mustChangePassword) {
        toast.warning("Please change your temporary password");
        nav("/change-password");
      } else {
        nav(u.role === "admin" ? "/admin" : u.role === "streamer" ? "/streamer" : "/player");
      }
    } catch (err) {
      toast.error(apiErrorMessage(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Session</div>
      <h1 className="font-display text-4xl font-black tracking-tighter mb-8">{t("auth.login")}</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.email")}</Label>
          <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">{t("auth.password")}</Label>
          <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-12 font-semibold transition-colors">
          {busy ? t("common.loading") : t("auth.login")}
        </Button>
      </form>
      <div className="mt-8 text-sm text-[#8B97AE] space-y-2">
        <div>
          {t("auth.noAccount")}{" "}
          <Link to="/register" className="text-white underline hover:text-[#2DD4A7]" data-testid="login-goto-register">{t("nav.register")}</Link>
        </div>
        <div>
          <Link to="/forgot-password" data-testid="login-goto-forgot" className="text-white underline hover:text-[#2DD4A7]">Forgot your password?</Link>
        </div>
      </div>
    </div>
  );
}
